/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import MobileMenu from './modules/MobileMenu';

const mobileMenu = new MobileMenu();



// WEBPACK FOOTER //
// ./src/assets/scripts/App.js